(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pl-bundle"] && !Shopify.designMode) return;
  try {
    (function () {
    var roots = document.querySelectorAll('[data-pl-bundle]');
    if (!roots.length) return;

    Array.prototype.forEach.call(roots, initBundle);

    function initBundle(root) {
      var dataEl = root.querySelector('[data-pl-bundle-data]');
      if (!dataEl) return;

      var data;
      try { data = JSON.parse(dataEl.textContent); } catch (e) { console.error('[pl-bundle] bad JSON', e); return; }

      // Running mode is a static, read-only info panel — just reveal it.


      var options = data.options || [];
      var available = options.filter(function (o) { return o.available; });
      if (!available.length) return; // nothing selectable — leave hidden

      if (!data.moneyFormat) return; // money format always comes from shop.money_format

      var strings = data.strings || {};
      var moneyFormat = data.moneyFormat;

      var slotsWrap = root.querySelector('[data-pl-bundle-slots]');
      var totalEl = root.querySelector('[data-pl-bundle-total]');
      var wasEl = root.querySelector('[data-pl-bundle-was]');
      var addBtn = root.querySelector('[data-pl-bundle-add]');
      var errorEl = root.querySelector('[data-pl-bundle-error]');
      var tierInputs = Array.prototype.slice.call(root.querySelectorAll('[data-pl-bundle-tier]'));

      // Pre-fill order: the variant the shopper is currently viewing comes first
      // (if it is available), then the other available options in their original
      // order. Slots beyond the list wrap around.
      var current = null;
      if (data.currentVariantId != null) {
        for (var ci = 0; ci < available.length; ci++) {
          if (String(available[ci].variantId) === String(data.currentVariantId)) { current = available[ci]; break; }
        }
      }
      var order = current
        ? [current].concat(available.filter(function (o) { return o !== current; }))
        : available;

      function money(cents) {
        var currency = window.Shopify && window.Shopify.currency && window.Shopify.currency.active;
        if (currency) return new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency',currency:currency}).format(cents / 100);
        return (cents / 100).toFixed(2);
      }

      function selectedTier() {
        var el = root.querySelector('[data-pl-bundle-tier]:checked') || tierInputs[0];
        return { count: parseInt(el.getAttribute('data-count'), 10), discount: parseInt(el.getAttribute('data-discount'), 10) };
      }

      function optionByVariant(id) {
        for (var i = 0; i < options.length; i++) {
          if (String(options[i].variantId) === String(id)) return options[i];
        }
        return null;
      }

      function buildSlots(count) {
        slotsWrap.innerHTML = '';
        for (var i = 0; i < count; i++) {
          var pre = order[i % order.length];

          var row = document.createElement('div');
          row.className = 'pl-bundle-slot';

          var label = document.createElement('span');
          label.className = 'pl-bundle-slot-label';
          label.textContent = (strings.slot || 'Pick') + ' ' + (i + 1);

          var sel = document.createElement('select');
          sel.className = 'pl-bundle-select';
          sel.setAttribute('data-pl-bundle-slot', '');
          sel.setAttribute('aria-label', label.textContent);

          options.forEach(function (o) {
            var opt = document.createElement('option');
            opt.value = o.variantId;
            opt.textContent = o.available ? o.title : (o.title + ' — ' + (strings.soldOut || 'Sold out'));
            if (!o.available) opt.disabled = true;
            sel.appendChild(opt);
          });

          sel.value = pre.variantId;
          sel.addEventListener('change', recalc);

          row.appendChild(label);
          row.appendChild(sel);
          slotsWrap.appendChild(row);
        }
      }

      function collect() {
        var selects = slotsWrap.querySelectorAll('[data-pl-bundle-slot]');
        var chosen = [];
        var hasUnavailable = false;
        Array.prototype.forEach.call(selects, function (s) {
          var o = optionByVariant(s.value);
          if (!o) return;
          if (!o.available) hasUnavailable = true;
          chosen.push(o);
        });
        return { chosen: chosen, count: selects.length, hasUnavailable: hasUnavailable };
      }

      function recalc() {
        var tier = selectedTier();
        var info = collect();
        var subtotal = 0;
        info.chosen.forEach(function (o) { subtotal += o.price; });
        var est = info.chosen.reduce(function (sum, o) { return sum + o.price - Math.floor(o.price * tier.discount / 100); }, 0);

        if (totalEl) totalEl.textContent = money(est);
        if (wasEl) {
          if (tier.discount > 0 && info.chosen.length) {
            wasEl.textContent = money(subtotal);
            wasEl.hidden = false;
          } else {
            wasEl.hidden = true;
          }
        }

        var ok = info.chosen.length === info.count && info.count === tier.count && !info.hasUnavailable;
        if (addBtn) addBtn.disabled = !ok;
      }

      function showError(msg) {
        if (addBtn) addBtn.disabled = false;
        if (errorEl) { errorEl.textContent = msg || strings.error || 'Something went wrong.'; errorEl.hidden = false; }
      }

      tierInputs.forEach(function (inp) {
        inp.addEventListener('change', function () {
          Array.prototype.forEach.call(root.querySelectorAll('.pl-bundle-tier'), function (l) { l.classList.remove('is-active'); });
          var label = inp.closest('.pl-bundle-tier');
          if (label) label.classList.add('is-active');
          buildSlots(selectedTier().count);
          recalc();
        });
      });

      if (addBtn) {
        addBtn.addEventListener('click', function () {
          var info = collect();
          if (info.hasUnavailable || info.chosen.length !== info.count) return;

          var map = {};
          info.chosen.forEach(function (o) { map[o.variantId] = (map[o.variantId] || 0) + 1; });
          var items = Object.keys(map).map(function (id) {
            return { id: parseInt(id, 10), quantity: map[id] };
          });

          addBtn.disabled = true;
          if (errorEl) errorEl.hidden = true; // clear only when a new add starts
          var addUrl = (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js';

          fetch(addUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: items })
          })
            .then(function (res) {
              return res.json().catch(function () { return {}; }).then(function (body) {
                return { ok: res.ok, body: body };
              });
            })
            .then(function (result) {
              if (!result.ok) {
                // Add failed (e.g. 422 out of stock): surface Shopify's message and
                // do NOT open the drawer — never fake a successful add.
                var msg = (result.body && (result.body.description || result.body.message)) || strings.error;
                showError(msg);
                return;
              }

              addBtn.classList.add('is-added');
              addBtn.textContent = strings.added || 'Added!';
              document.dispatchEvent(new CustomEvent('pl:cart:refresh', { bubbles: true }));
              document.dispatchEvent(new CustomEvent('pl:cart:open', { bubbles: true }));
              setTimeout(function () {
                addBtn.classList.remove('is-added');
                addBtn.textContent = strings.add || 'Add bundle to cart';
                addBtn.disabled = false;
              }, 1600);
            })
            .catch(function () {
              showError(strings.error);
            });
        });
      }

      // Reveal (progressive enhancement) and paint the initial state.
      root.hidden = false;
      buildSlots(selectedTier().count);
      recalc();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
